import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutePath } from '@common/enums';
import { AbilityService } from '@common/services/auth/ability.service';
import { AuthContextService } from '@common/services/auth/auth-context.service';

export const notDomainUserGuard: CanActivateFn = () =>
  !inject(AbilityService).isDomainUser() || inject(Router).createUrlTree([inject(AuthContextService).prefix() + RoutePath.NotFound]);
